import { colors } from 'ui/theme/colors';
import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const Trackpad = ({
  height = 25,
  width = 25,
  color = colors.grey90,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 25 25" {...props}>
    <path
      d="M6.3125 15.2546C5.71576 15.2546 5.14347 15.0176 4.72151 14.5956C4.29955 14.1737 4.0625 13.6014 4.0625 13.0046V6.25464C4.0625 5.6579 4.29955 5.08561 4.72151 4.66365C5.14347 4.24169 5.71576 4.00464 6.3125 4.00464H18.6875C19.2842 4.00464 19.8565 4.24169 20.2785 4.66365C20.7004 5.08561 20.9375 5.6579 20.9375 6.25464V13.0046C20.9383 13.5526 20.7385 14.0819 20.3758 14.4926"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.9374 20.8796L9.04991 17.0306C8.90722 16.8403 8.827 16.6105 8.82028 16.3728C8.81357 16.1351 8.88069 15.9011 9.01241 15.7031V15.7031C9.09922 15.5731 9.2116 15.4622 9.34269 15.3771C9.47378 15.292 9.62084 15.2345 9.7749 15.2081C9.92895 15.1817 10.0868 15.187 10.2387 15.2236C10.3907 15.2602 10.5335 15.3274 10.6587 15.4211L11.9337 16.3796V9.06934C11.9337 8.92129 11.9629 8.77469 12.0197 8.63796C12.0764 8.50122 12.1596 8.37703 12.2645 8.27252C12.3694 8.168 12.4938 8.08521 12.6307 8.0289C12.7677 7.97258 12.9144 7.94385 13.0624 7.94434V7.94434C13.3608 7.94434 13.6469 8.06287 13.8579 8.27385C14.0689 8.48483 14.1874 8.77097 14.1874 9.06934V13.5693L17.3179 14.2653C17.8519 14.384 18.3243 14.6931 18.6469 15.1348C18.9695 15.5765 19.1201 16.1206 19.0707 16.6653L18.6874 20.8818L11.9374 20.8796Z"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
